import parse from 'html-react-parser';
import Font from '../fragments/Font';
import { useMemo } from 'react';

const InformationSection = (props) => {

  const { windowDimensions, activeItemIndex, setActiveItemIndex, information, setActiveToolTip, informationPageToolTips } = props;
	const { windowHeight } = windowDimensions;
	
	const content = useMemo(() => {
		let textContent = information[activeItemIndex].text;
		if (textContent) {
			textContent = textContent.replaceAll('src="/storage', 'src="https://placeoddities.rifke.world/storage');
			return parse(textContent);
		}
		return null;
	}, [information, activeItemIndex]);

  return (
    <div
      className="information__section"
			style={{
				overflowY: 'scroll',
        maxHeight: windowHeight - 120 + 'px', 
        backgroundColor: information[activeItemIndex].backgroundColor
      }}
    >
      <Font item={information[activeItemIndex]} className={`information__section__inner--${information[activeItemIndex]._id}`} />
      <div className={`information__section__inner information__section__inner--${information[activeItemIndex]._id}`}>
        <header
          className="information__section__header"
          style={{
            backgroundColor: information[activeItemIndex].backgroundColor
          }}
        >
          <h2 className="information__section__heading">{information[activeItemIndex].title}</h2>
          <button
            className="information__section__button--close button b04 auto-width"
            onClick={() => {
              setActiveItemIndex(-1);
              let tooltipText = '';
              if (informationPageToolTips?.tooltips) {
                if (informationPageToolTips.tooltips[0]) {
                  tooltipText = informationPageToolTips.tooltips[Math.floor(Math.random() * informationPageToolTips.tooltips.length)].value;
                }
              }
              setActiveToolTip(tooltipText);
            }}
          >close</button>
        </header>
        <div className="information__section__content">
					{content ? content : ''}
        </div>
      </div>
    </div>
  )
}

export default InformationSection;